export enum DetailErrorType {
  FailedToLoadModel = 1,
  FailedToRefreshModel = 2,
}
